import { useCollectionStatsQuery } from 'lib-knowledge-management-common/graphql';

type UseCollectionStatsReturnType = {
  loading: boolean;
  articleCount: number | undefined;
  categoryCount: number | undefined;
  queueCount: number | undefined;
};

type UseCollectionStatsParams = {
  collectionId: string;
};
export function useCollectionStats({
  collectionId,
}: UseCollectionStatsParams): UseCollectionStatsReturnType {
  if (!collectionId) throw new Error('useCollectionStats: No collectionId');

  const { data, loading, error } = useCollectionStatsQuery({
    variables: { id: collectionId },
  });

  if (loading) {
    return {
      loading: true,
      articleCount: undefined,
      categoryCount: undefined,
      queueCount: undefined,
    };
  }

  if (error || !data || !data.collection)
    throw new Error(`No data returned for collection ${collectionId}`);

  return {
    loading,
    articleCount: data.collection.statistics.articleCount,
    categoryCount: data.collection.statistics.categoryCount,
    queueCount: data.collection.statistics.queueCount,
  };
}
